export default "__VITE_ASSET__1HtFTNNB__"